import { createContext, useEffect, useContext, useState } from "react";
import {auth, db} from '../firebase';
import {createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    onAuthStateChanged} from 'firebase/auth'
    import {setDoc,doc} from 'firebase/firestore'

//create an instance of the AuthContext
const AuthContext = createContext()

//Function to handle the authentication, authorization
//and update storage of a user and set the context values.
export function AuthContextProvider({children}){

    //set the current user (logged in).
    const [user,setUser] = useState({});

    //method to create a new user account and 
    //save the details in the Firebase. 
    function signUp(email,password){

        //Firebase method to create a new account in Firebase
        createUserWithEmailAndPassword(auth,email,password);

        //firestore method to initialize the savedShows for the user 
        //to []
        //create a new document in users collection, id:email.
        setDoc(
        //get a reference to a document in a Firestore users collection    
            doc(db,'users',email),{
            savedShows:[]
        })
       
    }

    //function that authenticates and signs in the user 
    //using the firebase auth sdk
    function logIn(email,password){
        return signInWithEmailAndPassword(auth,email,password);
    }

    //function that logs out the current user 
    //using the firebase auth sdk
    function logOut(){
        return signOut(auth)
    }

    
    useEffect(()=>{
        //subscribe to the changes in the state when the component mounts
        // or unmounts.
        const unsubscribe = onAuthStateChanged(auth,(currentUser)=>{
            setUser(currentUser);


        })

        return () =>{
            unsubscribe();
        }
    })

    //react component to pass context values down the component tree.
    //passing signup(),login(),logOut(), and user values.
    return (
        <AuthContext.Provider value={{signUp,logIn,logOut, user}}>
            {children}
        </AuthContext.Provider>
    )
}


export function UserAuth(){
    //function to consume the values created by the createContext()
    return useContext(AuthContext);
}